import { useTranslations } from 'next-intl';
import { ICheckoutSteps } from '@hooks/useCheckoutSteps';

const useLabels = () => {
  const tCart = useTranslations('Cart');
  const tCatalog = useTranslations('Catalog');
  const tCheckout = useTranslations('Checkout');

  const titleLabels = {
    [ICheckoutSteps.REGISTRATION]: tCheckout('Stepper.registration'),
    [ICheckoutSteps.DELIVERY]: tCart('myDelivery'),
    [ICheckoutSteps.PAYMENT]: tCart('myPayment'),
  };

  const goBackLabels = {
    [ICheckoutSteps.DELIVERY]: tCatalog('backToCart'),
    [ICheckoutSteps.PAYMENT]: tCatalog('backToDelivery'),
  };

  return { titleLabels, goBackLabels };
};

export default useLabels;
